
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TabsModule } from 'primeng/tabs';
import { SkeletonModule } from 'primeng/skeleton';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ScrollerModule } from 'primeng/scroller';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DragDropModule } from 'primeng/dragdrop';
import { TooltipModule } from 'primeng/tooltip';
import { ListboxModule } from 'primeng/listbox';
import { PopoverModule } from 'primeng/popover';
import { DropdownModule } from 'primeng/dropdown';
import { DatePickerModule } from 'primeng/datepicker';

const PrimeNGModules = [
  CommonModule,
  DialogModule,
  CheckboxModule,
  InputSwitchModule,
  RadioButtonModule,
  ButtonModule,
  ToggleSwitchModule,
  TabsModule,
  SkeletonModule,
  MultiSelectModule,
  AutoCompleteModule,
  ScrollerModule,
  OverlayPanelModule,
  DragDropModule,
  TooltipModule,
  ListboxModule,
  PopoverModule,
  DropdownModule,
  DatePickerModule
];


@NgModule({
  imports: PrimeNGModules,
  exports: PrimeNGModules,
  declarations: [
    
  ],
  providers: [
    DialogService,
    DynamicDialogConfig,
  ]
})
export class PrimeNGModule { }
